export const categories = [
  { value: 'government', label: 'Government & Policy' },
  { value: 'business', label: 'Business Conferences' },
  { value: 'networking', label: 'Networking Events' },
  { value: 'internal', label: 'Internal Events' },
  { value: 'awards', label: 'Awards & Recognition' },
];